export default __webpack_public_path__ + "tab1_video56dd07.mp4";